import request from "./request";
import { Bootstrap } from "../types/app";

const normalizeBootstrap = (data: any = {}): Bootstrap => ({
  ...data,
  timings: data.timings ?? [],
  socials: data.socials ?? [],
  cities: data?.cities ?? [],
});

const app = async (): Promise<Bootstrap> => {
  const { data } = await request({ url: "/v1/app" });
  return normalizeBootstrap(data);
};

const cities = async () => {
  const { data } = await request({ url: "/v1/app/cities" });
  return data?.cities ?? [];
};

const areas = async () => {
  const { data } = await request({ url: "/v1/app/areas" });
  return data?.areas ?? [];
};

const deliveryAreas = async () => {
  const { data } = await request({ url: "/v1/public/delivery-areas" });
  return data?.areas ?? [];
};

const verifyPromo = async (code: string) => {
  const { data } = await request({
    url: "/v1/public/promo/verify",
    method: "post",
    data: { code },
  });
  return data;
};

export default {
  app,
  cities,
  areas,
  deliveryAreas,
  verifyPromo,
  updateBanners: () => {},
};
